var _style, _g, _path, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sleep_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".sleep_svg__st0{display:none}.sleep_svg__st1{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}.sleep_svg__st4{fill:var(--color-icon-secondary)}.sleep_svg__st6{display:inline;fill:none;stroke:var(--color-text);stroke-width:3.2799;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sleep_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sleep_svg__st1",
    d: "M138.1 115.4H9.9V99.9c0-3.6 2.9-6.5 6.5-6.5h115.2c3.6 0 6.5 2.9 6.5 6.5v15.5zM17.1 134.9H9.9v-19.5h11.5v15.2c.1 2.4-1.9 4.3-4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sleep_svg__st1",
    d: "M138.1 134.9h-7.2c-2.4 0-4.3-1.9-4.3-4.3v-15.2h11.5v19.5zM126.2 77.1H109c-3.2 0-6.2 1.4-8.3 3.9l-3.6 4.3 3.6 4.3c2 2.5 5.1 3.9 8.3 3.9h17.2c3.2 0 6.2-1.4 8.3-3.9l3.6-4.3-3.6-4.3c-2.1-2.5-5.1-3.9-8.3-3.9zM108.3 77.1h15c2.8 0 5.4-1.2 7.2-3.4l3.1-3.8-3.1-3.8c-1.8-2.1-4.4-3.4-7.2-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2 70.1l13.5 21.3c-7.4 4.8-13.6.8-18.4-6.6L44.1 78 20.2 92.7c-2.3 1.4-5.3.7-6.7-1.5h0c-1.5-2.3-.8-5.3 1.5-6.8l22.2-14.2h0l4.3-2.7c3.9-2.5 9.2-1.3 11.7 2.6z",
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "sleep_svg__st1",
    d: "M84 48.7l-10.9 7.6c-4.4 3.1-5.3 9.5-1.9 13.5l-.8.5-11.9 8.1 8.1 12.8 28-17.9c2.6-1.7 3.4-5.1 1.7-7.7l-2.5-4C92 59.1 88.6 58.4 86 60l-8.1 5.1"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-13.226 108.98 55.487)",
    className: "sleep_svg__st1",
    cx: 109,
    cy: 55.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 31.7c-3-5.8-2-12.6 1.8-17.3-2.2.1-4.4.7-6.4 1.7-7.9 4-11 13.7-7 21.5 4 7.9 13.7 11 21.5 7 2.1-1.1 3.8-2.5 5.2-4.2-6.1.3-12.2-2.9-15.1-8.7z",
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sleep_svg__st4",
    cx: 74.5,
    cy: 34.7,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sleep_svg__st4",
    cx: 54.5,
    cy: 21.8,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sleep_svg__st4",
    cx: 94.5,
    cy: 21.8,
    r: 7.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 80.9c-9.7-18.9-6.6-41 5.9-56.5-7.1.4-14.3 2.2-21 5.6-25.8 13.1-36 44.5-22.9 70.2C31.5 125.9 63 136.1 88.7 123c6.8-3.4 12.4-8.2 16.9-13.7-20 1-39.6-9.5-49.2-28.4z",
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "sleep_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sleep_svg__st6",
    d: "M137.7 37.4c7.2 11.9 9.5 28.3 3.8 46.4-4.6 14.7-14.9 30.5-11.7 46.8l4.5 18.3M68.8 150.1c1.5-4.5 1.4-10.1.3-15.1-.6-2.9-2.9-5.3-5.8-6-2.7-.7-5.5-1-8.3-.9-2.9 0-5.8.5-8.6.2-6.6-.6-10.6-5-7.8-11.9 1.5-3.3-.1-5.4-1.1-7.3-3.1-5.6 1.5-6.9 1.5-10.8 0-1.7-1.4-3.1-3.1-3.3-2.5-.3-4.7-1.3-6-2.7-1.2-1.2-1.3-3-.5-4.5C40.9 69 38.5 73.9 42.5 47.6c2.6-17.2 21.8-37.7 60.2-31.3 4.7.8 9.3 1.9 13.7 3.6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sleep_svg__st4",
    d: "M137.6 32.5h-26.3l21-21h-18.8c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h29.3l-21 21h15.7c1.2 0 2.2 1 2.2 2.2s-.8 2.2-2.1 2.2zM126.4 68.9h-19.7l14.4-14.4h-11.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h21.8l-14.4 14.4h9.2c1.2 0 2.2 1 2.2 2.2-.1 1.2-1.1 2.2-2.3 2.2zM98.8 47.3H83.3l10.2-10.2h-6.4c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h17L93.9 42.9h4.9c1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2z"
  })));
}
export default SvgSleep;